import React from 'react';
import { CardElement } from 'react-stripe-elements';
import { Typography, Grid, Button } from '@material-ui/core/';
import { withStyles } from '@material-ui/core/styles';
import PaymentMethodStyles from '../../Styles/PaymentMethodStyles';
import { Context } from '../../Context';


class CardSection extends React.Component {
	render() {
		const { classes } = this.props;

		return (
			<Grid container spacing={0}>
				<Grid item xs={12}>
					<div className={classes.cardSection}>
						<CardElement style={{
							base: {
								fontSize: '16px'
							}
						}} />
					</div>
					{this.context.state.error && (
						<Typography variant='caption' className={classes.error}>
							{this.context.state.error}
						</Typography>
					)}
				</Grid>
				<Grid item xs={12} style={{ textAlign: 'right' }}>
					<Button type="submit" variant="contained" size="large" disabled={this.props.loading}>
						Add new card
						</Button>
				</Grid>
			</Grid>
		);
	}
}

CardSection.contextType = Context;

export default withStyles(PaymentMethodStyles)(CardSection);
